import { CheckoutSessionProvider } from "@circle-react/components/Paywalls/Checkout/contexts/CheckoutSessionContext";
import { ConfirmationRoute } from "@circle-react/components/Paywalls/CheckoutWithSession/routes/ConfirmationRoute";
import { rootRoute } from "@circle-react/routes/PaywallCheckout/tanstack_routes/__root";
import { createRoute } from "@tanstack/react-router";

export const confirmationRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/checkout/$checkoutPath/confirmation/$sessionId",
  component: Confirmation,
});

function Confirmation() {
  const { paywallId } = confirmationRoute.useRouteContext();
  const { sessionId: sessionIdParam } = confirmationRoute.useParams();

  const sessionId =
    sessionIdParam && !Number.isNaN(Number(sessionIdParam))
      ? Number(sessionIdParam)
      : null;

  return (
    <CheckoutSessionProvider paywallId={paywallId} sessionId={sessionId}>
      <ConfirmationRoute />
    </CheckoutSessionProvider>
  );
}
